import { Status } from 'civic-champs-shared/api/hooks'
import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { useCallback } from 'react'
import { OpportunityTemplate, OpportunityTemplateApiPayload } from 'volunteering/opportunities/interfaces'
import { useCurrentOrg } from 'civic-champs-shared/auth/hooks'

export const useUpdateOpportunityTemplate = (): [
  (id: number, body: OpportunityTemplateApiPayload) => Promise<OpportunityTemplate>,
  Status<OpportunityTemplate>,
] => {
  const org = useCurrentOrg()
  const [request, status] = useFetchRefactored<OpportunityTemplate>()

  const updateOpportunityTemplates = useCallback(
    (id: number, body: OpportunityTemplateApiPayload) => {
      return request({
        method: 'put',
        url: `/organizations/${org.id}/opportunity_templates/${id}`,
        config: {
          body,
        },
      })
    },
    [org.id, request],
  )

  return [updateOpportunityTemplates, status]
}

export default useUpdateOpportunityTemplate
